const initialState = (
    {
        apiData: {
            status: null,
            error: null,
            value: null
        },
        apiAccess: {
            value : [],
            error: null
        }
    }
)

export default initialState
